import { Button, Card } from "reactstrap";
import "../utils/detail.css";
import { useEffect, useState } from "react";
import { getPaymentLinkByBusiness, getPaymentLinkEdupaxByBusiness, getSummaryFeesEdupaxByBusiness } from "../services/developerApi";
import { Spin } from "antd";
import { FormatCurrency } from "../../../../common/format/formatCurrency";
const LienPaiement =({ developer})=>{
  const tabs = ["Liens marchands", "Edupax"];
  const [activeTab1, setActiveTab1] = useState("Liens marchands");
  const handleTabChange = (tab1) => setActiveTab1(tab1);
  const [paymentLinkBusiness, setPaymentLinkBusiness] = useState(null);
  const [paymentLinkEdupaxBusiness, setPaymentLinkEdupaxBusiness] = useState(null);
  const [loading, setLoading] = useState(false);
  const totalLinks = paymentLinkBusiness?.length || 0;
const activeLinks =
  paymentLinkBusiness?.filter((item) => item.active)?.length || 0;
  const totalEdupax = paymentLinkEdupaxBusiness?.length || 0;
const activeEdupax =
  paymentLinkEdupaxBusiness?.filter((item) => item.status === "ACTIVE")?.length || 0;
useEffect(() => {
  const fetchPaymentLinks = async () => {
    setLoading(true);
    try {
      const res = await getPaymentLinkByBusiness(developer?.id);
      setPaymentLinkBusiness(Array.isArray(res) ? res : res?.data || []);
      
    } catch (error) {
      console.error("Erreur :", error);
      setPaymentLinkBusiness([]);
    } finally {
      setLoading(false);
    }
  };

  if (developer?.id) {
    fetchPaymentLinks();
  }
}, [developer?.id]);
  const handleCopy = (text) => {
  if (!text) return;
  navigator.clipboard.writeText(text);
};
const handleCopyEdupax = (text) => {
  if (!text) return;
  navigator.clipboard.writeText(text);
};
const [visibleCount, setVisibleCount] = useState(4);
const visibleData = paymentLinkBusiness?.slice(0, visibleCount);
const [loadingEdupax, setLoadingEdupax] = useState(false);
useEffect(() => {
  const fetchPaymentLinkEdupaxBusiness = async () => {
    setLoadingEdupax(true);
    try {
      const res = await getPaymentLinkEdupaxByBusiness(
        developer?.id,
        developer?.apiKey,
        developer?.apiToken
      );

      const data = res?.data;
      setPaymentLinkEdupaxBusiness(
        Array.isArray(data) ? data : data ? [data] : []
      );
    } catch (error) {
      console.error("Erreur :", error);
      setPaymentLinkEdupaxBusiness([]);
    } finally {
      setLoadingEdupax(false);
    }
  };
  if (developer?.id && developer?.apiKey && developer?.apiToken) {
    fetchPaymentLinkEdupaxBusiness();
  }
}, [developer]);
const [summaryMap, setSummaryMap] = useState({});
useEffect(() => {
  const fetchSummary = async () => {
    if (!paymentLinkEdupaxBusiness || !developer) return;
    const currentMonth = getCurrentMonth();
    const map = {};
    for (const item of paymentLinkEdupaxBusiness) {
      const campagneMonth = getLastClosedMonth(item.closedMonths);
      try {
        const currentRes = await getSummaryFeesEdupaxByBusiness(
          developer.apiKey,
          developer.apiToken,
          currentMonth
        );
        const campagneRes = await getSummaryFeesEdupaxByBusiness(
          developer.apiKey,
          developer.apiToken,
          campagneMonth
        );

        map[item.id] = {
          current: currentRes?.data,
          campagne: campagneRes?.data
        };

      } catch (e) {
        console.error(e);
        map[item.id] = null;
      }
    }

    setSummaryMap(map);
  };

  fetchSummary();
}, [paymentLinkEdupaxBusiness, developer]);
const formatMonth = (month) => {
  if (!month) return "-";

  const [year, m] = month.split("-");
  const date = new Date(year, m - 1);

  return date.toLocaleString("fr-FR", { month: "long" });
};
const getLastClosedMonth = (closedMonths) => {
  if (!closedMonths) return null;

  const today = new Date();

  const monthsArray = closedMonths.split(",");

  const validMonths = monthsArray.filter((m) => {
    const date = new Date(m + "-01");

    // 🔥 STRICTEMENT avant aujourd’hui (pas <=)
    return date < new Date(today.getFullYear(), today.getMonth(), 1);
  });

  const sorted = validMonths.sort((a, b) => new Date(b) - new Date(a));

  return sorted[0];
};
const getCurrentMonth = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");

  return `${year}-${month}`;
};
    return(
 <>
 <div className="link">Liens de paiement du business</div>
 <div className="tab-link">
 <div className="mb-3">
  <div
    className="tabs-scroll"
    style={{
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
    }}
  >
    {tabs.map((tab1) => (
      <button
        key={tab1}
        onClick={() => handleTabChange(tab1)}
        className={`tab-btn ${
          activeTab1 === tab1 ? "active" : ""
        }`}
        type="button"
      >
        {tab1}
      </button>
    ))}
  </div>
</div>
<>
{activeTab1 === "Liens marchands" && (
  <>
  <div className="number-actif mb-3">
  {activeLinks} liens actifs sur {totalLinks} au total
</div>
  {loading ? (
  <div style={{ textAlign: "center", padding: "20px" }}>
    ⏳ <Spin/>
  </div>
): !paymentLinkBusiness || paymentLinkBusiness.length === 0 ? (
      <div style={{ textAlign: "center", padding: "20px" }}>
        📭 Aucun lien de paiement
      </div>
    ):
      visibleData.map((item, index) => (
        <Card
          key={index}
          style={{
            width: "100%",
            backgroundColor: "#F8F8F8",
            borderRadius: "10px",
            padding: "10px",
            border: "1px solid #F8F8F8",
            fontSize: "12px",
            marginBottom: "10px"
          }}
        >
          <div
            className="grid-links"
            style={{ alignItems: "center", marginBottom: "6px" }}
          >
            <span
              style={{ fontWeight: 600, fontSize: "13px" }}
              className="title-link"
            >
              {item.description || "Lien de paiement"}
              <span
                style={{
                  backgroundColor: item.active ? "#EBFFEA" : "#FFF0F0",
                  color: item.active ? "#349C32" : "#D41C1C",
                  padding: "2px 6px",
                  borderRadius: "100px",
                  fontSize: "10px",
                  marginLeft: "6px"
                }}
              >
                {item.active ? "✓ Active" : "✗ Inactif"}
              </span>
            </span>

            <span className="sous-title-link">Montant (fixe)</span>
            <span className="sous-title-link">Revenus générés</span>
          </div>

          {/* INFOS */}
       <div className="grid-links">
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      minWidth: 0 
    }}
  >
    <span
      className="sous-title-link"
      style={{
        flex: 1,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }}
      title={item.paymentLink}
    >
      {item.paymentLink || "-"}
    </span>

    <span
      onClick={() => handleCopy(item.paymentLink)}
      style={{
        cursor: "pointer",
        fontSize: "14px"
      }}
      title="Copier"
    >
      📋
    </span>
  </div>

  {/* MONTANT */}
  <span className="title-link">
    {item.amount || 0} XOF
  </span>

  {/* REVENUS */}
  <span className="title-link">
    {item.totalRevenue || 0} XOF
  </span>

</div>
  </Card>
      ))
    }
    {visibleCount < paymentLinkBusiness?.length && (
  <div style={{ textAlign: "center", marginTop: "10px" }}>
    <Button 
      onClick={() => setVisibleCount(prev => prev + 4)}
      className="filtrer"
    >
      Voir plus
    </Button>
  </div>
)}
  </>
)}
  </>

 {activeTab1 === "Edupax" && (
  <>
   <div className="number-actif mb-3">
  {activeEdupax} liens actifs sur {totalEdupax} au total
</div>
  {loadingEdupax ? (
      <div style={{ textAlign: "center", padding: "20px" }}>
        ⏳ <Spin />
      </div>
    ):!paymentLinkEdupaxBusiness || paymentLinkEdupaxBusiness.length === 0 ? (
      <div style={{ textAlign: "center", padding: "20px" }}>
        📭 Aucun lien Edupax
      </div>
    ):(
      paymentLinkEdupaxBusiness.map((item, index) => {
         const paymentUrl = item.publicToken
    ? `${process.env.REACT_APP_PAXITY_FEES}/${item.publicToken}`
    : "-";
    const campagneMonth = getLastClosedMonth(item.closedMonths);
    const currentMonth = item.currentMonth || getCurrentMonth();
    const summary = summaryMap[item.id];
    return(
        <Card
          key={index}
          style={{
            width: "100%",
            backgroundColor: "#F8F8F8",
            borderRadius: "10px",
            padding: "10px",
            border: "1px solid #F8F8F8",
            fontSize: "12px",
            marginBottom: "10px"
          }}
        >
          <div className="grid-links" style={{ marginBottom: "6px" }}>
            <span className="title-link" style={{ fontWeight: 600 }}>
              {item.schoolName || "Abonnement"}
              <span
                style={{
                  backgroundColor: item.status=="ACTIVE" ? "#EBFFEA" : "#FFF0F0",
                  color: item.status==="ACTIVE" ? "#349C32" : "#D41C1C",
                  padding: "2px 6px",
                  borderRadius: "100px",
                  fontSize: "13px",
                  marginLeft: "6px"
                }}
              >
                {item.status ? "✓ Active" : "✗ Inactif"}
              </span>
            </span>

            <span className="sous-title-link">Montant reçu {formatMonth(currentMonth)}</span>
            <span className="sous-title-link">Montant attendu {formatMonth(currentMonth)}</span>
          </div>
          <div className="grid-links">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                minWidth: 0 
              }}
            >
            <span className="sous-title-link">{paymentUrl}</span>
             <span
              onClick={() => handleCopyEdupax(paymentUrl)}
              style={{
                cursor: "pointer",
                fontSize: "14px"
              }}
              title="Copier"
            >
              📋
            </span>
            </div>
            <span className="title-link">{FormatCurrency(summary?.current?.totalPaid || 0)}</span>
            <span className="title-link">{FormatCurrency(summary?.current?.totalDue || 0)}</span>
          </div>

          <hr style={{ margin: "8px 0" }} />
          <div className="grid-links">
            <span className="sous-title-link">
              Campagne {formatMonth(campagneMonth)}
            </span>
            <span className="sous-title-link">Montant reçu</span>
            <span className="sous-title-link">Revenus attendu</span>
          </div>
          <div className="grid-links">
            <span></span>
            <span className="title-link">{FormatCurrency(summary?.campagne?.totalPaid || 0)}</span>
            <span className="title-link">{FormatCurrency(summary?.campagne?.totalPaid || 0)}</span>
          </div>
        </Card>
      );}
    )
    ) }
  </>
)}
 </div>
</>
);
}
export default LienPaiement;